import { appThemaColors } from "./colorConst";

/**
 * Definition of Web application variants routed in this SPA.
 */
export const enum AppVariants {
  SdcAdmin = 1,
  Fulltech,
  Owner,
  AutolockOperator,
  SocialOperator,
}

/**
 * Get the page title to display as the tab name in browser, for the specified
 * AppVariant.
 */
export const documentTitleOf = (variant: AppVariants): string => {
  switch (variant) {
    case AppVariants.SdcAdmin:
      return "ハウディ利用アプリ";
    case AppVariants.Fulltech:
      return "フルテック利用アプリ";
    case AppVariants.Owner:
      return "LAD契約者（オーナー）利用アプリ";
    case AppVariants.AutolockOperator:
      return "オペレータ利用アプリ";
    case AppVariants.SocialOperator:
      return "オペレータ利用アプリ(ミライロドア)";
  }
};

/**
 * Get the page title to display on the header, for the specified AppVariant.
 */
export const headerTitleOf = (variant: AppVariants): string => {
  switch (variant) {
    case AppVariants.SdcAdmin:
      return "SDC管理";
    case AppVariants.Fulltech:
      return "SDC設置・LAD契約者（オーナー）管理";
    case AppVariants.Owner:
      return "物件詳細・オペレーター管理";
    case AppVariants.AutolockOperator:
      return "ドア管理・利用者管理";
    case AppVariants.SocialOperator:
      return "ミライロドア管理";
  }
};

/**
 * Get the sub domain name assigned for the specified AppVariant.
 */
export const subdomainNameOf = (variant: AppVariants): string => {
  switch (variant) {
    case AppVariants.SdcAdmin:
      return "sdc-admin";
    case AppVariants.Fulltech:
      return "fulltech";
    case AppVariants.Owner:
      return "owner";
    case AppVariants.AutolockOperator:
      return "autolock";
    case AppVariants.SocialOperator:
      return "social";
  }
};

/**
 * Get the full domain name assigned for the specified AppVariant.
 */
export const domainNameOf = (variant: AppVariants): string => {
  return subdomainNameOf(variant) + "." + process.env.REACT_APP_DOMAIN_BASE;
};

/**
 * Get the full localhost address assigned for the specified AppVariant.
 * @example 'localhost:3001'
 */
export const localDebugAddressOf = (variant: AppVariants): string => {
  let port: number;
  switch (variant) {
    case AppVariants.SdcAdmin:
      port = 3003;
      break;
    case AppVariants.Fulltech:
      port = 3001;
      break;
    case AppVariants.Owner:
      port = 3002;
      break;
    case AppVariants.AutolockOperator:
      port = 3000;
      break;
    case AppVariants.SocialOperator:
      port = 3005;
      break;
  }
  return `localhost:${port}`;
};

/**
 * Get the Cognito user group names that are allowed to access the specified
 * AppVariant.
 */
export const userGroupsOf = (variant: AppVariants): string[] => {
  switch (variant) {
    case AppVariants.SdcAdmin:
      return ["sdc-admin"];
    case AppVariants.Fulltech:
      return ["fulltech"];
    case AppVariants.Owner:
      return ["aal-owner"];
    case AppVariants.AutolockOperator:
      return ["autolock"];
    case AppVariants.SocialOperator:
      return ["social"];
  }
};

/**
 * Get path to the favicon file for the specified AppVariant.
 */
export const favIconPathOf = (variant: AppVariants): string => {
  let filename: string;
  switch (variant) {
    case AppVariants.SdcAdmin:
      filename = "haudi.ico";
      break;
    case AppVariants.Fulltech:
      filename = "fulltech.ico";
      break;
    case AppVariants.Owner:
      filename = "owner.ico";
      break;
    case AppVariants.AutolockOperator:
      filename = "aal_operator.ico";
      break;
    case AppVariants.SocialOperator:
      filename = "sci_operator.ico";
      break;
  }
  return `${process.env.PUBLIC_URL}/${filename}`;
};

/**
 * Get the color code assigned to access the specified AppVariant.
 * @example '#50a69f'
 */
export const titleColorOf = (variant: AppVariants): string => {
  switch (variant) {
    case AppVariants.SdcAdmin:
      return appThemaColors.haudi;
    case AppVariants.Fulltech:
      return appThemaColors.fulltech;
    case AppVariants.Owner:
      return appThemaColors.owner;
    case AppVariants.AutolockOperator:
      return appThemaColors.aal_operator;
    case AppVariants.SocialOperator:
      return appThemaColors.sci_operator;
  }
};
